import {customerCmdService, customerQueryService} from '../index'

class Team {
    getActiveTeamMembers = id => customerQueryService.get(`team/${id}/members`)
    getInvitationsMembers = id => customerQueryService.get(`team/${id}/invitations`)
    addTeamMember = (id, data) => customerCmdService.post(`team/${id}/invitation`, data)
    deleteTeamMember = (teamId, id) => customerCmdService.delete(`team/${teamId}/member/${id}`)
    deleteInvitation = (teamId, data) => customerCmdService.delete(`team/${teamId}/invitation`, {data})
    remindTeamMember = (id, data) => customerCmdService.post(`team/${id}/invitation/reminder`, data)
    getTeams = () => customerQueryService.get('/teams')
    addTeam = data => customerCmdService.post('/team', data)
    updateTeam = (id, data) => customerCmdService.put(`team/${id}`, data)
    deleteTeam = id => customerCmdService.delete(`/team/${id}`)
    updateTeamMember = (teamId, id, data) => customerCmdService.patch(`team/${teamId}/member/${id}`, data)
}

export default new Team()
